/**
 * NOTE Pannellum is not a module,
 * it should only be imported and instantiated once
 */
import 'pannellum/src/js/pannellum';
import 'pannellum/src/js/libpannellum';

export const pannellum = (window as any).pannellum;
